import { useState } from "react";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Content, PaginationTableFilter, PaginationTable, ButtonLink, Icon } from "@webtypen/react-components";
import { Page } from "../../components/Page";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-regular-svg-icons";

export const EmployeesOverview = () => {
    const [filter, setFilter] = useState({});

    return (
        <Page
            icon={faUsers}
            title="Mitarbeiter"
            actions={[<ButtonLink to="/employees/new/edit">Mitarbeiter anlegen</ButtonLink>]}
        >
            <Content>
                <PaginationTableFilter
                    definition={{
                        lastname: { type: "text", label: "Nachname" },
                        firstname: { type: "text", label: "Vorname" },
                        email: { type: "text", label: "E-Mail" },
                        number: { type: "text", label: "Mitarbeiter-Nr." },
                    }}
                    filter={filter}
                    setFilter={setFilter}
                />
                <PaginationTable
                    url="/api/employees/list"
                    tableAttributes={{ className: "valign-middle" }}
                    payload={{ filter: filter }}
                    columns={[
                        { label: "Nummer", attributes: { style: { width: 90 } } },
                        { label: "Name" },
                        { label: "Aktiv", attributes: { style: { width: 60 } } },
                        { label: "Optionen", attributes: { style: { width: 130 }, className: "text-right" } },
                    ]}
                    render={(row, i) => (
                        <tr key={i}>
                            <td>{row.number ? row.number : "-"}</td>
                            <td>
                                {row.firstname}
                                {row.lastname ? (row.lastname ? " " : "") + row.lastname : ""}
                                <div style={{ fontSize: 10 }}>{row.email}</div>
                            </td>
                            <td>
                                {row.is_active ? (
                                    <Icon icon={faCheckCircle} className="text-success" />
                                ) : (
                                    <Icon icon={faTimesCircle} />
                                )}
                            </td>
                            <td className="text-right">
                                <ButtonLink to={"/employees/" + row._id + "/edit"} sm>
                                    Bearbeiten
                                </ButtonLink>
                            </td>
                        </tr>
                    )}
                />
            </Content>
        </Page>
    );
};
